import { UserWorkoutSession } from '../../entities';

export const hasWorkoutInviteExpired = (workoutInvite: UserWorkoutSession, dateOfRequest: Date): boolean => {
  const originalEndTime: number | undefined = workoutInvite.originalEndTime &&
    workoutInvite.originalEndTime.getTime();
  const workoutEndTime: number = Math.max(originalEndTime || 0, workoutInvite.endTime.getTime());
  const workoutInviteHasExpired = dateOfRequest.getTime() > workoutEndTime;
  return workoutInviteHasExpired;
};
